import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EoHttpClient, IHttpParams } from '../../common/eo-http-client.service';
import { STATUS } from '../../common/use-loading.model';
import { countries } from './country.mock';
import { Country } from './country.model';

@Injectable({
  providedIn: 'root'
})
export class EoCountryDropdownService {
  countries$ = new BehaviorSubject<Country[]>([]);
  status$ = new BehaviorSubject<STATUS>(STATUS.pending);
  error$ = new BehaviorSubject<string | null>(null);

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    private http: EoHttpClient
  ) {}

  getCountries(url?: string): Observable<Country[]> {
    const apiUrl = url ?? `${this.apiUrl}/v1/Countries`;
    const param: IHttpParams = {
      url: apiUrl,
      success$: this.countries$,
      status$: this.status$,
      error$: this.error$,
    };

    return this.http.get<Country[]>(param);
  }

  getCountriesMock(): Observable<Country[]> {
    this.status$.next(STATUS.loading);
    const obs$ = new Observable<Country[]>((sub) => {
      setTimeout(() => {
        sub.next(countries);
        this.countries$.next(countries);
        this.status$.next(STATUS.success);
      }, 1000);
    });

    return obs$;
  }
}
